import React from 'react'

import Link from 'components/Link'
import Meta from 'components/Meta'
import PasswordResetForm from 'components/PasswordResetForm'
import UnauthBox from 'components/UnauthBox'
import UnauthView from 'components/UnauthView'
import paths from 'constants/paths'

export default function PasswordReset() {
  const title = 'Reset your password'

  return (
    <UnauthView className="PasswordReset">
      <Meta title={title} />
      <UnauthBox
        title={title}
        actions={
          <Link to={paths.SIGN_IN} icon="plus-circle" muted>Sign in</Link>
        }>
        <p>
          Enter your email
        </p>
        <PasswordResetForm />
      </UnauthBox>
    </UnauthView>
  )
}



// WEBPACK FOOTER //
// ./src/views/PasswordReset/PasswordReset.js